import React, { Component } from "react";
import { connect } from "react-redux";

import * as requestsActions from "../../redux/actions/requests";
// import * as filtersActions from '../../redux/actions/filters';
import { getProfileFilters } from "../../../../SystemSettings/redux/actions/filters/filters";

import { Typography } from "antd";
import ConfigTableColumns from "../../components/Requests/ConfigTableColumns/ConfigTableColumns";
// import PlacemarkMap from '../../../common/PlacemarkMap/PlacemarkMap';
import TopPanel from "../../components/Requests/TopPanel/TopPanel";
// import FiltersInfoPanel from '../../components/Requests/FiltersInfoPanel/FiltersInfoPanel';
import Filters from "../../components/Requests/Filters/Filters";
import RequestsTable from "../../components/Requests/Table/Table";

import "../../../Order/containers/Orders/Orders.css";
import "./Requests.css";

import moment from "moment";
import Footer from "../../../../../common/hoc/withFooter";
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import { debounce } from "lodash";
const { Text } = Typography;
const { watchRequest, unwatchRequest, getFilterRequests } = requestsActions;

class Requests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMap: false,
      isDrawerVisible: false,
      drawerCols: {
        info: true,
        customer: true,
        view: true,
        state: true,
        passengers: true,
        price: false,
        routeLength: false,
        arrivalDatetime: true,
        placeDelivery: true,
        settlementForm: false,
        driver: false,
        finalDestination: false,
        dateCreation: false,
        statusSendingACBDPL: false,
        sendingTrafficPolice: false,
        requestType: true
      },
      tableColumnsLen: 0,
      showFilterAll: false,
      filter: {},
      searchField: "",
      pagination: {
        page: 1,
        limit: 5,
        total: null
      },
      watched: null,
      replied: null,
      requestsType: "all",
      timeout: false,
      activeFiltersCount: null,
      visibleSuccessSaveFilter: false,
      visibleAcceptSaveFilter: false,
      selectedRowKeys: [],
      changed: false,
      sortedColumn: null
    };
    this.state.tableColumnsLen = this.getTableColumnsLen();
    this.fetchSearchStringDebounced = debounce(this.fetchSearchString, 1200);
  }

  componentDidMount() {
    this.updateData();
    if (!this.props.settingsFilters) {
      this.props.getProfileFilters();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.requests !== this.props.requests) {
      this.updateData();
    }
    if (this.state.changed !== prevState.changed) {
      // Отправляем запрос на каждое изменение стейта в заявках.
      this.fetchFilterRequest();
    }
  }

  // общая функция для отправки данных на сервер
  fetchFilterRequest = () => {
    this.props.getFilterRequests({
      ...this.state.filter,
      type: this.state.requestsType,
      watched: this.state.watched,
      page: this.state.pagination.page,
      limit: this.state.pagination.limit,
      searchField: this.state.searchField,
      replied: this.state.replied,
      sort: this.state.sortedColumn
    });
  };

  sortByColumn = e => {
    this.setState({
      ...this.state,
      sortedColumn: e,
      changed: !this.state.changed
    });
  };

  updateData = () => {
    if (this.props.requests) {
      if (this.props.pagination) {
        this.setState({
          pagination: {
            ...this.state.pagination,
            total: this.props.pagination.total
          }
        });
      }
    }
  };

  toggleAllFilter = () => {
    this.setState(() => ({
      showFilterAll: !this.state.showFilterAll
    }));
  };

  toggleSaveCurrentFilter = () => {
    this.setState(() => ({
      visibleSuccessSaveFilter: !this.state.visibleSuccessSaveFilter
    }));
  };

  toggleAcceptCurrentFilter = () => {
    this.setState(() => ({
      visibleAcceptSaveFilter: !this.state.visibleAcceptSaveFilter
    }));
  };

  toggleVisibleMap = () => {
    const visibleMap = this.state.visibleMap;

    this.setState(() => ({
      visibleMap: !visibleMap
    }));
  };

  onChangeWatchedList = e => {
    let watchedRequest = e.target.value === "true" ? "watched" : "unwatched";
    this.setState({
      watched: watchedRequest === this.state.watched ? null : watchedRequest,
      changed: !this.state.changed,
      pagination: { ...this.state.pagination, page: 1 }
    });
  };

  onChangeRepliedList = e => {
    let repliedRequest = e.target.value === "true" ? "replied" : "notReplied";
    this.setState({
      replied: repliedRequest === this.state.replied ? null : repliedRequest,
      changed: !this.state.changed,
      pagination: { ...this.state.pagination, page: 1 }
    });
  };

  onChangeTypeList = e => {
    let statusRequest = e.target.value;
    this.setState({
      requestsType: statusRequest,
      changed: !this.state.changed,
      pagination: { ...this.state.pagination, page: 1 }
    });
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.setState({
      searchField: value
    });
    this.fetchSearchStringDebounced();
  };

  fetchSearchString = () => {
    this.fetchFilterRequest();
  };

  onColsChange = e => {
    const { drawerCols } = this.state;
    const newDrawerCols = {
      ...drawerCols,
      [e.target.name]: e.target.checked
    };
    const tableColumnsLen = this.getTableColumnsLen(newDrawerCols);
    this.setState({
      drawerCols: newDrawerCols,
      tableColumnsLen
    });
  };

  getTableColumnsLen = (drawerCols = null) => {
    return Object.values(
      drawerCols ? drawerCols : this.state.drawerCols
    ).reduce((count, val) => (val === true ? ++count : count), 0);
  };

  showDrawer = () => {
    this.setState({
      isDrawerVisible: true
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerVisible: false
    });
  };

  renderColumns = () => {
    const { drawerCols: columns } = this.state;
    const filteredCols = [];
    let cols = [
      {
        title: "Номер заявки",
        title_full: "Номер заявки (Наименование)",
        dataIndex: "info",
        key: "info",
        render: info => (
          <span>
            <Text>
              {/* todo убрать регулярки  */}
              {info && info.requestNumber
                ? getNumberWithoutSpaces(info.requestNumber)
                : ""}
            </Text>
            <br />
            {info.change && info.change !== info.create ? (
              <Text>Изменен: {moment(info.change).format("DD.MM.YYYY")}</Text>
            ) : info.create ? (
              <Text type="secondary">
                Создан: {moment(info.create).format("DD.MM.YYYY")}
              </Text>
            ) : null}
          </span>
        ),
        sorter: true
      },
      {
        title: "Заказчик",
        dataIndex: "customer",
        key: "customer",
        render: customer => (
          <span>
            <Text>
              {customer && customer.nameLegal
                ? customer.nameLegal
                : customer.subjectKey === "physical"
                ? (customer.lastname
                    ? customer.lastname[0].toUpperCase() +
                      customer.lastname.slice(1) +
                      " "
                    : "") +
                  (customer.name ? customer.name[0].toUpperCase() + "." : "") +
                  (customer.patronymic
                    ? customer.patronymic[0].toUpperCase() + "."
                    : "")
                : " - "}
            </Text>
            <br />
            <Text type="secondary">
              {customer && customer.subject ? customer.subject : ""}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Дата подачи",
        title_full: "",
        dataIndex: "arrivalDatetime",
        key: "arrivalDatetime",
        render: arrivalDatetime =>
          arrivalDatetime ? (
            <span>
              {moment(arrivalDatetime).format("DD.MM.YYYY HH:mm")}
              <br />
              <Text type="secondary">{moment(arrivalDatetime).fromNow()}</Text>
            </span>
          ) : null,
        sorter: true
      },
      {
        title: "Место подачи",
        title_full: "",
        dataIndex: "placeDelivery",
        key: "placeDelivery",
        render: placeDelivery => (
          <span style={{ whiteSpace: "normal" }}>
            <Text>
              {placeDelivery && placeDelivery.address
                ? placeDelivery.address
                : ""}
            </Text>
            <br />
            <Text type="secondary">
              {placeDelivery && placeDelivery.city ? placeDelivery.city : ""}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Вид",
        title_full: "Вид транспортной услуги",
        dataIndex: "view",
        key: "view",
        render: view => (
          <span>
            <Text style={{ textTransform: "uppercase" }}>
              {view && view.abbr ? view.abbr : ""}
            </Text>
            <br />
            <Text style={{ color: view && view.color ? view.color : "" }}>
              {view && view.description ? view.description : ""}
            </Text>
          </span>
        ),
        sorter: true
      },
      {
        title: "Пасс.",
        title_full: "Количество пассажиров",
        dataIndex: "passengers",
        key: "passengers",
        render: passengers => (
          <span>{passengers === "0" ? "—" : passengers}</span>
        ),
        sorter: true
      },
      // {
      //   title: "Тип",
      //   dataIndex: "requestType",
      //   key: "requestType",
      //   render: requestType => (
      //     <span>
      //       {requestType && requestType.requestType
      //         ? requestType.requestType
      //         : ""}
      //     </span>
      //   ),
      //   sorter: true
      // }
    ];

    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    return filteredCols;
  };

  handleClickRow = row => {
    return {
      onClick: () => {
        !row.watched && this.props.watchRequest([row.id]);
        this.props.history.push(`/executorship/request/${row.id}`);
      }
    };
  };

  onPageChange = e => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        limit: e.pageSize,
        page: e.current
      },
      changed: !this.state.changed
    });
  };

  onPageSizeChange = e => {
    this.setState({
      pagination: { ...this.state.pagination, page: 1, limit: parseInt(e) },
      changed: !this.state.changed
    });
  };

  onChangeRowSelection = row => {
    this.setState(state => ({
      ...state,
      selectedRowKeys: row
    }));
  };

  handleFiltersChange = values => {
    // Лаконичнее решение не смог придумать. Увы
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key] || values[key] === 0) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    this.setState({
      filter: val,
      activeFiltersCount: Object.keys(val).length,
      changed: !this.state.changed
    });
  };

  handleFooterAction = action => {
    const { selectedRowKeys } = this.state;
    selectedRowKeys.length > 0 &&
      this.props[`${action}Request`](selectedRowKeys);
    setTimeout(() => {
      this.setState({ selectedRowKeys: [] });
    }, 1000);
  };

  resetFilters = () => {
    this.setState({
      filter: null,
      searchField: null,
      activeFiltersCount: null,
      changed: !this.state.changed
    });
  };

  render() {
    const {
      isDrawerVisible,
      drawerCols,
      showFilterAll,
      pagination,
      requestsType,
      searchField,
      watched,
      replied,
      filter,
      visibleMap,
      activeFiltersCount,
      tableColumnsLen,
    } = this.state;

    const {
      watchedTypes,
      repliedTypes,
      requests,
      settingsFilters,
      requestsLoading
    } = this.props;

    return (
      <div className="orders">
        <ConfigTableColumns
          columns={drawerCols}
          visible={isDrawerVisible}
          close={this.closeDrawer}
          changed={this.onColsChange}
        />
        <div className="orders__content">
          <TopPanel
            typesList={this.props.requestTypes}
            onChangeTypeList={this.onChangeTypeList}
            requestsType={requestsType}
            searchFieldValue={searchField}
            onChangeSearch={this.onChangeSearch}
            watched={watched}
            replied={replied}
            watchedTypes={watchedTypes}
            repliedTypes={repliedTypes}
            onChangeWatchedList={this.onChangeWatchedList}
            onChangeRepliedList={this.onChangeRepliedList}
          />
          <div className="orders__filters">
            {/*<FiltersInfoPanel
              visibleSuccessSaveFilter={this.state.visibleSuccessSaveFilter}
              visibleAcceptSaveFilter={this.state.visibleAcceptSaveFilter}
              visibleMap={this.state.visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              resetFilters={this.resetFilters}
              toggleAcceptCurrentFilter={this.toggleAcceptCurrentFilter}
              toggleSaveCurrentFilter={this.toggleSaveCurrentFilter}
            />*/}
            <Filters
              filterData={filter}
              showFilterAll={showFilterAll}
              showDrawer={this.showDrawer}
              toggleAllFilter={this.toggleAllFilter}
              handleFiltersChange={this.handleFiltersChange}
              requests={requests}
              visibleMap={visibleMap}
              toggleVisibleMap={this.toggleVisibleMap}
              settingsFilters={
                settingsFilters &&
                settingsFilters.req &&
                settingsFilters.req.keys
              }
              resetFilters={this.resetFilters}
              activeFiltersCount={activeFiltersCount}
            />
          </div>
          {/* Я пока не выяснил для чего это используется. Поэтому не удалял*/}
          {/* <div className="orders__map">
            {this.state.visibleMap && <PlacemarkMap markers={markers} />}
          </div> */}
          <RequestsTable
            // rowSelection={rowSelection}
            renderColumns={this.renderColumns}
            tableColumnsLen={tableColumnsLen}
            requests={requests}
            requestsLoading={requestsLoading}
            // onChangeTable={this.onChangeTable}
            pagination={pagination}
            sortByColumn={this.sortByColumn}
            onPageSizeChange={this.onPageSizeChange}
            onPageChange={this.onPageChange}
            handleClickRow={this.handleClickRow}
            onChangeRowSelection={this.onChangeRowSelection}
          />
        </div>
        <Footer>
          {/*<RequestsFooter handleFooterAction={this.handleFooterAction} />*/}
        </Footer>
      </div>
    );
  }
}

export default connect(
  state => {
    const { requests } = state.Executorship.Requests;
    const { profileFilters } = state.SystemSettings.filters;
    return {
      requestsLoading: requests.requestsLoading,
      requests: requests.allRequests,
      requestTypes: requests.requestTypes,
      watchedTypes: requests.watchedTypes,
      repliedTypes: requests.repliedTypes,
      pagination: requests.pagination,
      settingsFilters: profileFilters
    };
  },
  {
    getFilterRequests,
    watchRequest,
    unwatchRequest,
    getProfileFilters
  }
)(Requests);
